import PageWrapper from '../components/basic/PageWrapper';
import HeroSection from '../components/components/AboutUsPage/HeroSection';
import ReasonSection from '../components/components/AboutUsPage/ReasonSection';
import AboutUsPageHelmet from '../components/components/AboutUsPage/AboutUsPageHelmet';
import SupplyChainSection from '../components/components/HomePage/SupplyChainSection';
import OurAchievements from '../components/components/HomePage/OurAchievements';
import DetailSection from '../components/components/AboutUsPage/DetailSection';

const AboutUsPage = () => {
	return (
		<>
			<AboutUsPageHelmet />
			<PageWrapper>
				<HeroSection />

				<DetailSection />

				<div className='my-16'>
					<SupplyChainSection />
				</div>

				<ReasonSection />

				<OurAchievements />
			</PageWrapper>
		</>
	);
};

export default AboutUsPage;
